import SpriteImage from "@PUBLIC/P/images/ico/ico_spr.png";
import styled, {css} from "styled-components";

const SearchIcon = styled.i<{icon: string}>`
	display: block;
	width: 18px;
	margin-right: 10px;
	background-image: url(${SpriteImage});
	background-size: 400px 400px;

	${props => {
		if (props.icon === "calendar") {
			return css`
				height: 20px;
				background-position: -20px 0;
			`;
		}
		if (props.icon === "member") {
			return css`
				height: 21px;
				background-position: -40px 0;
			`;
		}
		if (props.icon === "map") {
			return css`
				height: 23px;
				background-position: 0px 0;
			`;
		}
	}}
`;

export default SearchIcon;
